import { Transforms } from 'slate';

import application from 'application';

import { toggleBlock } from '../../3rd-party/rich-text';
import elementTypes from '../../elements/types';
import HelptapEditor from '../';
import * as baseNodeUtilities from './base-node';

export function getDefaultOptions() {

  const theme = application.getCurrentStartup().theme;
  const options = {
    ...baseNodeUtilities.getDefaultOptions(),
    url: '',
    width: '200px',
    backgroundColor: theme.colors.primary,
    textColor: theme.colors.background,
    alignment: 'center',
    options: {
      id: 'button-' + performance.timeOrigin + performance.now(),
      hoverBackgroundColor: theme.colors.secondary,
      hoverTextColor: theme.colors.primary,
      clickHandler: `function successHandler(page, button, authData, supportingData) {
  
}`
    },
    padding: [0, 0, 0, 0],
    radius: [5, 5, 5, 5],
    height: '50px',
    children: [{
      text: 'Button Text'
    }]
  };

  return options;

}

export function insert(editor, path) {

  const node = {
    ...getDefaultOptions(),
    type: elementTypes.AUTHENTICATOR_BUTTON
  };

  HelptapEditor.insertNode(editor, node, path);

}

export function toggle(editor) {

  const nodeOptions = {
    ...getDefaultOptions(),
    type: elementTypes.AUTHENTICATOR_BUTTON
  };
  toggleBlock(editor, nodeOptions.type, nodeOptions);
  Transforms.insertText(editor, 'Button Text');

}

export function cloneNode(node) {

  const clonedNode = HelptapEditor.cloneNode(node);

  clonedNode.options = {
    ...clonedNode.options,
    id: 'button-' + performance.timeOrigin + performance.now()
  };

  return clonedNode;

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = cloneNode(node);

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}